import HoverTooltip from '@deltek/specification-client/core/Feedbacks/HoverTooltip'
import { ContentLibrary } from '@deltek/specification-client/core/Models/product'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Typography } from '@material-ui/core'
import React from 'react'
import { TVData } from '../../ProductCardManagementPage.types'

const ContentLibraryCell = ({ row }: TVData) => {
    const text = !!row.original
        ? ContentLibrary[
              row.original.contentLibrary as keyof typeof ContentLibrary
          ]
        : ''

    return (
        <HoverTooltip text={text}>
            <Typography
                style={{
                    fontSize: pxToRem(14),
                    fontFamily: 'Roboto',
                }}
                noWrap
            >
                {text}
            </Typography>
        </HoverTooltip>
    )
}

export default ContentLibraryCell
